"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.formLoginsMap = void 0;
const utils_1 = require("@aws-amplify/core/internals/utils");
const AuthError_1 = require("../../../errors/AuthError");
function formLoginsMap(idToken) {
    const issuer = (0, utils_1.decodeJWT)(idToken).payload.iss;
    const res = {};
    if (!issuer) {
        throw new AuthError_1.AuthError({
            name: 'InvalidIdTokenException',
            message: 'Invalid Idtoken.',
        });
    }
    const domainName = issuer.replace(/(^\w+:|^)\/\//, '');
    res[domainName] = idToken;
    return res;
}
exports.formLoginsMap = formLoginsMap;
